<template>
  <div>

    <TitlePage :title="$t('fields')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6" >
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathCreate" v-if="getRoleName !== 'Collaboratore'">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>
      </v-col>
      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler" v-if="getRoleName !== 'Collaboratore'"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile class="px-4 py-4">
      <v-row class="align-center">
        <v-col cols="12" md="3" class="pt-2 pb-0" v-if="getUser.super_admin">
          <CenterSelectSearch
              v-model="filter.center_id"
              :multiple="false"
              :includeAllOption="true"
              autoStrategy="user"
              :returnObject="false"
              @message="setCenterId"
          />
        </v-col>
        <v-col cols="12" md="3" class="pt-2 pb-0">
          <SportsSelectSearch
              v-model="filter.sport_id"
              :multiple="false"
              :returnObject="false"
              :includeAllOption="true"
              @message="(id) => { filter.sport_id = id }"
          />
        </v-col>
        <v-spacer />

        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilter">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>


    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.sports_info="{ item }">
          <v-chip v-for="sport in item.sports_info" :key="item._id+sport.name" small class="mr-1">
            {{sport.name}}
          </v-chip>
        </template>

        <template v-slot:item._id="{ item }">
          <router-link :to="`/fields/settings/${item._id}`">
            {{ item._id }}
          </router-link>
        </template>

        <template v-slot:item.center_name="{ item }">
          <template v-if="isSuperAdmin">
            <router-link target="_blank" rel="noopener" :to="`/centers?_id=${item.center._id}`">
              {{ item.center.name }}
            </router-link>
          </template>
          <template v-else>
            {{ item.center.name }}
          </template>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>

            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="primary">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="edit(item._id)" :title="$t('edit')" dense v-if="getRoleName !== 'Collaboratore'">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>{{ $t('edit') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="settings(item._id)" :title="$t('settings')" dense v-if="getRoleName !== 'Collaboratore'">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-soccer-field</v-icon>Impostazione Prezzi
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="calendar(item._id)" :title="$t('settings')+' '+$t('calendar')" dense v-if="getRoleName !== 'Collaboratore'">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-table-settings</v-icon>{{$t('settings')}} {{ $t('calendar') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="liveCalendar(item._id)" :title="$t('bookings')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-calendar</v-icon>Gestione Prenotazioni
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="confirmRemove(item._id)" :title="$t('delete')" v-if="getRoleName !== 'Collaboratore'">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-delete</v-icon>{{ $t('delete') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch v-model="item.active" inset @change="updateSingleStatus(item)" dense hide-details class="mt-0" v-if="getRoleName !== 'Collaboratore'"></v-switch>
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import SportsAutocompleteSingle from "@/components/admin/SportsAutocompleteSingle";
import CenterSelectSearch from "@/components/filters/CenterSelectSearch.vue";
import SportsSelectSearch from "@/components/filters/SportsSelectSearch.vue";

const exportService = require('@/services/export')

export default {
  name: 'Fields',
  components: {
    SportsSelectSearch,
    CenterSelectSearch, SportsAutocompleteSingle, CenterAutocomplete,ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      pathCreate: '/fields/create/',
      pathEdit: '/fields/edit/',
      pathSettings: '/fields/settings/',
      pathCalendar: '/fields/calendar/',
      pathLiveCalendar: '/fields/live-calendar/',
      pathMasterCalendar: '/fields/master-calendar/',
      search: '',
      selected: [],
      headers: [
        { text: this.$t('Id'), align: 'start', value: '_id'},
        { text: this.$t('sportCenter'), align: 'start', value: 'center.name'},
        { text: this.$t('sports'), align: 'start', value: 'sports_info', sortable: false},
        { text: this.$t('name'), align: 'start', value: 'name'},
        { text: this.$t('status'), value: 'status', sortable: false},
        { text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      filter: {},
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100]
    };
  },
  async created(){
    this.filter = Object.assign({},this.getFilter)
    this.options_pagination = Object.assign({},this.getOptionsPagination)

    if(this.$route.query.center_id && this.getUser.super_admin){
      this.filter.center_id = this.$route.query.center_id
    }else {
      delete this.filter.center_id
    }

    await this.makeSearch()
    this._debouncedSearch = this.debounce(async () => { await this.makeSearch(true); }, 350);

  },
  watch: {
    'filter.center_id': function(){ this._debouncedSearch(); },
    'filter.sport_id': function(){ this._debouncedSearch(); }
  },
  computed: {
    ...mapGetters({
      'getFilter':'fields/getFilter',
      'getOptionsPagination':'fields/getOptionsPagination',
      'getUser':'user/getUser',
      'getRoleName': 'user/getRoleName'
    }),
    isSuperAdmin(){
      return (this.getUser && this.getUser.super_admin) ? this.getUser.super_admin : false;
    },
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'fields/index',
      'updateItem':'fields/update',
      'deleteItem': 'fields/delete',
      'massiveDeleteItem': 'fields/massDelete',
      'setFilter': 'fields/setFilter',
      'setOptionsPagination': 'fields/setOptionsPagination',
    }),

    debounce(fn, wait){
      var t = null; return function(){ var ctx=this,args=arguments;
        clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx,args); }, wait);
      };
    },

    async resetFilter(){
      var filters = Object.assign({},this.getFilter)
      for (const property in filters) {
        filters[property] = null
      }
      this.filter = Object.assign({}, filters)
      this.options_pagination = Object.assign({},{
        page: 1,
        limit: 10
      })
      await this.makeSearch()
    },
    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      var results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },

    settings(id){
      this.$router.push(this.pathSettings+id)
    },

    calendar(id){
      this.$router.push(this.pathMasterCalendar+id)
    },
    liveCalendar(id){
      this.$router.push(this.pathLiveCalendar+id)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },

    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.remove(mode)
      }else if(this.typeDelete == 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async updateSingleStatus(item){

      await this.setLoading(true);
      var result = await this.updateItem({id:item._id, item: {active: item.active}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async setCenterId(id){
      this.filter.center_id = id
    },
    async setSportId(sport){
      this.filter.sport_id = sport._id
    },
    async getNewPage(){
      await this.makeSearch();
    },
    calculatePagination(count, limit){

      var divide = (count / limit)
      var rest = divide % 1

      if(rest > 0){
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    }
  },
  mounted() {

  },
}
</script>
